import axios from 'axios';

const BASE = process.env.REACT_APP_BASE_URL || '/mlapi';

export const ScoringMatrixService = {
    getForRecruitment: async (recruitmentId) => {
        const { data } = await axios.get(`${BASE}/chat/scoring-matrix/${recruitmentId}`);
        return data;
    },
};
